export * from './getBookingType';
export * from './math';

export const withLizTitle = name => `${name} - LIZ Smart Office`;
